import { render, staticRenderFns } from "./Activity_selfhelp.vue?vue&type=template&id=65d357f8"
import script from "./Activity_selfhelp.vue?vue&type=script&lang=js"
export * from "./Activity_selfhelp.vue?vue&type=script&lang=js"
import style0 from "./Activity_selfhelp.vue?vue&type=style&index=0&id=65d357f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports